var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 14.9058C15.0604 14.9058 14.3875 15.2026 13.8729 15.6675L6.81719 11.5625C6.86667 11.335 6.90625 11.1075 6.90625 10.8701C6.90625 10.6327 6.86667 10.4052 6.81719 10.1777L13.7937 6.11224C14.3281 6.60682 15.0307 6.91346 15.8125 6.91346C17.4552 6.91346 18.7812 5.58799 18.7812 3.94599C18.7812 2.30399 17.4552 0.978516 15.8125 0.978516C14.1698 0.978516 12.8438 2.30399 12.8438 3.94599C12.8438 4.18338 12.8833 4.41089 12.9328 4.6384L5.95625 8.70383C5.42187 8.20925 4.71927 7.90261 3.9375 7.90261C2.29479 7.90261 0.96875 9.22808 0.96875 10.8701C0.96875 12.5121 2.29479 13.8376 3.9375 13.8376C4.71927 13.8376 5.42187 13.5309 5.95625 13.0363L13.0021 17.1512C12.9526 17.359 12.9229 17.5766 12.9229 17.7942C12.9229 19.3867 14.2193 20.6825 15.8125 20.6825C17.4057 20.6825 18.7021 19.3867 18.7021 17.7942C18.7021 16.2016 17.4057 14.9058 15.8125 14.9058Z",
    fill: "#5F46FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a56f2cfdc843555db7a09dee5508b07f.svg";
export { ForwardRef as ReactComponent };